<template>
  <div class="animated efficiency">
    <div>
      <filters :scope="filtersScope">
      </filters>
    </div>
    <ProductTabs></ProductTabs>
    <div class="statistic-wrap">
      <div class="card statistic-table" >
        <div>
          <div class="card-header" v-if="title">
            {{ title }}
          </div>
          <div class="card-block card-zz">
            <table class="table">
              <thead>
              <tr>
                <th v-for="col in headColumns" :colspan="col.colspan">{{ col.label }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="col in rowsAll">
                <td>{{ col.offer }}</td>
                <td>{{ col.lead }}</td>
                <td>{{ col.quantity }}</td>
                <td><p v-for="i in col.goods" class="goods">{{i.title}} -> {{i.quantity}}</p></td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <th v-for="cell in computedFootColumnsAll">
                  <span>{{ cell.value }}</span>
                </th>
              </tr>
              </tfoot>
            </table>
          </div>
          <div v-for="(rowsDate,indexDate) in rows" style="margin-bottom: 40px;">
            <div class="card-header" v-if="title">
              {{ indexDate }}
            </div>
            <table class="table">
              <thead>
              <tr>
                <th v-for="col in headColumns" :colspan="col.colspan">{{ col.label }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="col in rowsDate">
                <td>{{ col.offer }}</td>
                <td>{{ col.leads }}</td>
                <td>{{ col.quantity }}</td>
                <td><p v-for="i in col.goods" class="goods">{{i.title}} -> {{i.quantity}}</p></td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                  <th v-for="cell in computedFootColumns1[indexDate]">
                      <span>{{ cell.value }}</span>
                  </th>
              </tr>
              </tfoot>
            </table>
          </div>
          <br/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Filters from '../../../components/Filters.vue'
  import API from '../../../api/API'
  import Storage from '../../../api/Storage'
  import { map } from 'lodash'
  import Helper from '../../../api/Helper'
  import ProductTabs from './ProductTabs.vue'
  import StatisticTable from '../../../components/StatisticTable.vue'

  export default {
    name: 'ProductCountry',
    components: {
      Filters,
      StatisticTable,
      ProductTabs
    },
    data () {
      return {
        filtersScope: {
          dateFilter: true
        },
        form: {
          product: null,
          orders_count: null,
          price: null,
          provider: null,
          delivery_time: null,
          status: null,
          comment: null
        },
        title: this.$root.$t('pages.by_country'),
        isLoading: false,
        isBlock: false,
        Storage: Storage,
        Helper: Helper,
        country: null,
        headColumns: [
          {label: this.$root.$t('statistic.offer'), field: 'offer'},
          {label: this.$root.$t('statistic.leads'), field: 'leads'},
          {label: this.$root.$t('statistic.quantity'), field: 'quantity'},
          {label: this.$root.$t('statistic.products'), field: 'products'}
        ],
        footColumnsByDay: {},
        footColumnsAll: {},
        rows: [],
        rowsAll: []
      }
    },
    computed: {
      computedFootColumnsAll () {
        if (!this.columns) {
          return this.footColumnsAll
        } else {
          let footColumns = {}
          map(this.footColumnsAll, (d, i) => {
            if (this.columns[i] || i === 'label' || this.columns[i.replace('Percents', '')]) {
              footColumns[i] = d
            }
          })
          return footColumns
        }
      },
      computedFootColumns1 () {
        if (!this.columns) {
          return this.footColumnsByDay
        } else {
          let footColumns = {}
          map(this.footColumnsByDay, (d, i) => {
            if (this.columns[i] || i === 'label' || this.columns[i.replace('Percents', '')]) {
              footColumns[i] = d
            }
          })
          return footColumns
        }
      }
    },
    mounted () {
      this.calculateRows()
      this.getGoodsById()
      this.$root.$on('filters_load_new_data', () => {
        this.calculateRows()
        this.getGoodsById()
      })
    },
    methods: {
      calculateRows: function () {
        this.$root.$emit('data_loading')
        this.rows = []
        this.rowsAll = []
        API.getRemnantsCountry().then(response => {
          if (response.status === 200) {
            map(Storage.offers, (offer) => {
              let leads = null
              let leadsTotal = null
              let quantityTotal = null
              let goodsTotal = null
              let goodsByDayArr = []
              let quantity = null
              let goodsByDay = {}
              let allTotalByDay = []
              let allTotalByDayGoods = []
              let goodsQantity = []
              let filterGoods = []
              let storageOfferDay = {}
              let allByDayFoot = {}
              let storageOffer = {
                offer: null,
                quantity: null,
                lead: null
              }
              map(Storage.goods, good => {
                goodsQantity.push({
                  title: good.name,
                  id: good.id,
                  quantity: 0
                })
              })
              map(response.body, (offers, date) => {
                allTotalByDay = {
                  dateBy: date,
                  leads: 0,
                  quantity: 0
                }
                allTotalByDayGoods = {
                  dateBy: date,
                  goods: 0
                }
                goodsByDay = {}
                storageOfferDay[date] = []
                allByDayFoot[date] = {}
                map(offers, (offerInner, offerId) => {
                  if (allTotalByDay.dateBy === date) {
                    allTotalByDay.quantity += parseInt(offerInner.quantity)
                    allTotalByDay.leads += parseInt(offerInner.count)
                  }
                  leadsTotal += parseInt(offerInner.count)
                  quantityTotal += parseInt(offerInner.quantity)
                  if (offer.id === parseInt(offerId)) {
                    quantity += parseInt(offerInner.quantity)
                    leads += parseInt(offerInner.count)
                  }
                  map(offerInner.goods, (goods, goodsId) => {
                    if (allTotalByDayGoods.dateBy === date) {
                      allTotalByDayGoods.goods += parseInt(goods)
                    }
                    goodsByDay = {
                      title: Helper.getGoodNameById(Storage.goods, goodsId),
                      quantity: goods,
                      goodsByDayDate: date,
                      goodsByDayDateOfferId: parseInt(offerId)
                    }
                    goodsByDayArr.push(goodsByDay)
                    goodsTotal += parseInt(goods)
                    if (offer.id === parseInt(offerId)) {
                      goodsQantity.map(goodQuantity => {
                        if (goodQuantity.id === parseInt(goodsId)) {
                          goodQuantity.quantity += goods
                        }
                      })
                      filterGoods = goodsQantity.filter(good => good.quantity !== 0)
                      storageOffer = {
                        offer: Helper.getOfferTitle(Storage.offers, offerId),
                        quantity: quantity,
                        lead: leads,
                        goods: filterGoods
                      }
                    }
                  })
                  storageOfferDay[date].push({
                    offer: Helper.getOfferTitle(Storage.offers, offerId),
                    leads: offerInner.count,
                    quantity: offerInner.quantity,
                    goods: goodsByDayArr.filter(good => good.goodsByDayDate === date && good.goodsByDayDateOfferId === parseInt(offerId))
                  })
                })
                allByDayFoot[date] = {
                  offer: {
                    value: ''
                  },
                  leads: {
                    value: allTotalByDay.leads
                  },
                  quantity: {
                    value: allTotalByDay.quantity
                  },
                  goods: {
                    value: allTotalByDayGoods.goods
                  }
                }
              })
              this.footColumnsAll = {
                offer: {
                  value: ''
                },
                leads: {
                  value: leadsTotal
                },
                quantity: {
                  value: quantityTotal
                },
                goods: {
                  value: goodsTotal
                }
              }
              this.footColumnsByDay = allByDayFoot
              this.rowsAll.push(storageOffer)
              this.rowsAll = this.rowsAll.filter(function (i) { return i.quantity })
              this.rows = storageOfferDay
            })
          }
          this.$root.$emit('data_loaded')
        })
      },
      getOffers () {
        return new Promise(function (resolve, reject) {
          API.getOffers(Helper.getCountryList()).then(res => {
            if (res.status === 200) {
              Storage.offers = res.body
              resolve(true)
            }
          }).catch(error => {
            reject(error)
          })
        })
      },
      getGoodsById () {
        API.getRemnantsCountryById()
          .then(res => {
            Storage.goods = res.body
          }).catch(error => {
            console.log(error)
          })
      }
    }
  }
</script>
<style scoped>
  .goods {
    margin-bottom: 5px !important;
  }
</style>



// WEBPACK FOOTER //
// ProductCountry.vue?437d80e6